<template>
  <div>
    <label class="switch" @click="updateValue()">
      <span class="slider" :class="{ enabled: transformedValue }"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: "switchCustom",
  props: ["value"],
  computed: {
    transformedValue() {
      if (
        this.value === true ||
        this.value === "true" ||
        this.value === 1 ||
        this.value === "1"
      ) {
        return true;
      }
      if (
        this.value === false ||
        this.value === "false" ||
        this.value === 0 ||
        this.value === "0"
      ) {
        return false;
      }
      return false;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", !this.transformedValue);
      this.$emit("change");
    }
  }
};
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &.enabled {
    background-color: #1fa92a;
  }
  &.enabled {
    box-shadow: 0 0 1px #1fa92a;
  }
  &.enabled:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
</style>
